import React from 'react'
import { useNavigate } from 'react-router-dom'
import GradientButton from '../components/GradientButton'
import { readCurrentFarm } from '../utils/farmWizard'
import { useStoredPrincipal } from '../hooks/useStoredPrincipal'

function loadCurrentFarm() {
  return readCurrentFarm()
}

export default function Navegate(){
  const navigate = useNavigate()
  const farm = loadCurrentFarm()
  const principal = useStoredPrincipal()
  const canManageFarms = !principal || principal.role === 'editor' || principal.role === 'admin'

  return (
    <div style={{ maxWidth: 760 }}>
      <h2 className="h2">Continue setup</h2>
      <p className="lead">Quickly jump to sections to finish registering the facility and its operational data.</p>

      <div className="form-card" style={{ marginTop: 12 }}>
        <h3 style={{ marginTop: 0 }}>Current facility</h3>
        {!farm && (
          <p>
            No facility loaded.
            {canManageFarms ? (
              <>
                {' '}Go back to{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    navigate('/new-farm')
                  }}
                >
                  New Facility
                </a>{' '}
                to create one.
              </>
            ) : null}
          </p>
        )}

        {farm && (
          <div style={{ display: 'grid', gap: 6 }}>
            <div><strong>{farm.name || 'Unnamed facility'}</strong></div>
            <div style={{ color: '#444', fontSize: 14 }}>{farm.classification ? `Classification: ${farm.classification}` : ''}</div>
            <div style={{ color: '#444', fontSize: 14 }}>{farm.geography ? `Geography: ${farm.geography}` : ''}</div>
            <div style={{ color: '#444', fontSize: 14 }}>{farm.typeCulture ? `Type culture: ${farm.typeCulture}` : ''}</div>
            <div style={{ color: '#444', fontSize: 14 }}>{farm.species ? `Species: ${Array.isArray(farm.species) ? farm.species.join(', ') : farm.species}` : ''}</div>
            <div style={{ color: '#444', fontSize: 14 }}>{farm.stage ? `Stage: ${farm.stage}` : ''}</div>
            <div style={{ color: '#444', fontSize: 14 }}>{farm.productionUnits ? `${farm.productionUnits.length} production unit(s)` : '0 production units'}</div>
          </div>
        )}

        <hr />

        <div style={{ display: 'grid', gap: 8 }}>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <GradientButton onClick={() => navigate('/database')}>Database</GradientButton>
            <GradientButton onClick={() => navigate('/water')}>Water</GradientButton>
            <GradientButton onClick={() => navigate('/feed')}>Feed</GradientButton>
            <GradientButton onClick={() => navigate('/biomas')}>Biomas</GradientButton>
            <GradientButton onClick={() => navigate('/todos')}>Todos</GradientButton>
            <GradientButton onClick={() => navigate('/home')}>Home</GradientButton>
          </div>

          <div style={{ marginTop: 8 }}>
            <button type="button" onClick={() => navigate('/production-unit')}>Back: Production Unit</button>
          </div>
        </div>
      </div>
    </div>
  )
}
